
















































import { clone, chunk, flatten } from 'lodash';
import {
    PosWaypoint, PosWaypointType, PosSourceType, PosRoute,
} from 'gl-ms-positions';
import HereMap from '@/components/common/map/map.vue';
import HereGroup from '@/components/common/map/group.vue';
import { getSingleMarkerPosition, zoomToRadius } from '@/components/common/map/helpers';
import positions from '@/services/positions';
import Route from './components/route.vue';
import {
    ACTION_SET_WAYPOINT_BY_INDEX, ACTION_DELETE_WAYPOINT, ACTION_NEW_ROUTE, ACTION_NEW_EMPTY_ROUTE, ACTION_SET_EMPTY_WAYPOINT_BY_INDEX, ACTION_DELETE_EMPTY_WAYPOINT,
} from '../../../store/modules/planning';
import { getStaticUrl } from '../../../helpers';

export default {
    data() {
        return {};
    },
    components: {
        HereMap,
        HereGroup,
        Route,
    },
    computed: {
        getEmptyRoute(this: any) { return this.$store.getters.getEmptyRoute; },
        getRoute(this: any) { return this.$store.getters.getActiveRoute; },
        getOriginalRoute(this: any) { return this.$store.getters.getOriginalRoute; },
        getOriginalEmptyRoute(this: any) { return this.$store.getters.getOriginalEmptyRoute; },
        hasRouteChanged(this: any) { return Boolean(this.$store.getters.editing); },
        hasEmptyRouteChanged(this: any) { return Boolean(this.$store.getters.editingEmpty); },
        getEmptyWaypoints(this: any) { return this.$store.getters.getEmptyWaypoints; },
        getWaypoints(this: any) { return this.$store.getters.getWaypoints; },
        isMapLoading(this: any) {
            return this.$store.getters.isMapLoading;
        },
        mapLoadingText(this: any) {
            return this.$store.state.planning.loading;
        },
    },
    methods: {
        async recalculateEmptyRoute(this: any, data: any) {
            await this.$store.commit(ACTION_SET_EMPTY_WAYPOINT_BY_INDEX, data);
            await this.$store.dispatch(ACTION_NEW_EMPTY_ROUTE);
        },
        async recalculateRoute(this: any, data: any) {
            await this.$store.commit(ACTION_SET_WAYPOINT_BY_INDEX, data);
            await this.$store.dispatch(ACTION_NEW_ROUTE);
        },

        async removeMarker(this: any, item: PosWaypoint) {
            if (item.type === PosWaypointType.DRAG) {
                this.$store.commit(ACTION_DELETE_WAYPOINT, item);
                await this.$store.dispatch(ACTION_NEW_ROUTE);
            }
        },
        async removeEmptyMarker(this: any, item: PosWaypoint) {
            if (item.type === PosWaypointType.DRAG) {
                this.$store.commit(ACTION_DELETE_EMPTY_WAYPOINT, item);
                await this.$store.dispatch(ACTION_NEW_EMPTY_ROUTE);
            }
        },
    },
};
